import React, { useEffect, useState } from 'react';
import { Button } from '@wordpress/components';
import { __experimentalInputControl as InputControl } from '@wordpress/components';

function ColorControl(props) {
    
    const id = props.idx
    const [color, setColor] = useState()
    const handleChange = ( color ) => props.handleColorChange({idx:id,color:color});

    return (
        <div className="wp-picker-container">
            <Button className="button wp-color-result"
                aria-expanded="false"
                style={{backgroundColor:color ?? props.color}}
            >
                <span className="wp-color-result-text">
                    <InputControl
                        className="color-picker-hex wp-color-picker" 
                        name="color"
                        data-index={props.idx}
                        type="text" 
                        placeholder={color} 
                        data-default-color={color}
                        value={color ?? props.color}
                        onChange={ ( newColor ) => {
                            setColor( newColor ?? props.color )
                            handleChange( newColor )
                         }}
                        />
                </span>
            </Button>
        </div>
    );

}
export default ColorControl